<template>
  <div>
    <el-table
      :data="getDefaultTableText"
      style="width: 100%"
      size="mini"
      :fit="true"
      v-if="!$breakpoint.mdAndDown"
      :header-cell-class-name="tableHeaderClass"
      :highlight-current-row="false"
    >
      <el-table-column label="Products" width="180">
        <template slot-scope="scope">
          <span class="customFontSizeTable pl-2">
            {{ getDefaultRowText(scope.$index) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column v-for="product in pagedProductData" :key="product.fuelId">
        <template slot="header">
          {{ product ? product.fuelName : "" }}
        </template>
        <template slot-scope="scope">
          <span class="customFontSizeData">
            {{ getRowData(product, scope.$index) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column v-for="index in getRemainingColumnsToFillTable" :key="index"> </el-table-column>
    </el-table>
    <div
      class="py-2"
      v-else
      v-for="(header, index) in getDefaultTableText"
      :key="header.fuelId"
      :class="{ 'remove-text-alignment': $breakpoint.mdAndDown }"
    >
      <el-card>
        <el-row :gutter="20" class="customLineHeight customFontSizeData">
          <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
            <span class="font-weight-bold"> {{ getDefaultRowText(index) }} </span>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="customLineHeight" v-for="product in pagedProductData" :key="product.fuelId">
          <el-col :xs="12" :sm="12" class="pt-1 customFontSizeData">
            <span class="font-weight-bold"> {{ product ? product.fuelName : "" }} </span>
          </el-col>
          <el-col :xs="12" :sm="12" class="pt-1 customFontSizeData text-right">
            <span class="customFontSizeData">
              {{ getRowData(product, index) }}
            </span>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <el-row type="flex" justify="center" class="pt-3 pb-2">
      <div>
        <el-button class="pt-2 btn btn-text" @click="previousPage" :key="page" :disabled="page == 1"
          ><i class="fas fa-lg fa-chevron-left mr-2"></i> Previous {{ page == 1 ? 0 : pageSize }} Products
        </el-button>
      </div>
      <div style="padding-top: 1px">
        <el-pagination
          small
          layout="pager"
          :current-page="page"
          :page-size="pageSize"
          @current-change="setPage"
          :total="getTableHeaders.length"
        >
        </el-pagination>
      </div>
      <div>
        <el-button class="pt-2 btn btn-text" @click="nextPage" :key="page" :disabled="page === getPageCount"
          >Next {{ getNextPageCount }} Products <i class="fas fa-lg fa-chevron-right ml-2"></i
        ></el-button>
      </div>
    </el-row>
  </div>
</template>

<script>
import { rulesEnum } from "@/util/enums/rules";
import breakpoint from "@/mixins/index";
export default {
  components: {},
  mixins: [breakpoint],
  props: {
    productData: {
      type: Array,
      default: () => [],
    },
    productPrices: {
      type: Array,
      default: () => [],
    },
    isSettlementWindow: {
      type: Boolean,
      default: false,
    },
    isPricingEngine: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      pageSize: 5,
      page: 1,
      defaultTableText: [
        { title: `Prices (${rulesEnum.eUnitType.UsdPerMetricTonne.display})`, field: "price" },
        { title: "Settle Base Price (ppl)", field: "totalFixed" },
        { title: "Market Change (ppl)", field: "marketChange" },
        { title: "Live Base Price (ppl)", field: "totalLive" },
      ],
    };
  },
  computed: {
    getDefaultTableText() {
      if (!this.isSettlementWindow && !this.isPricingEngine) {
        return this.defaultTableText;
      } else if (this.isSettlementWindow) {
        return this.defaultTableText.filter((obj) => obj.field !== "price");
      } else if (this.isPricingEngine) {
        this.defaultTableText = this.defaultTableText.filter((obj) => obj.field !== "price");
        this.defaultTableText[0].field = "settlePrice";
        this.defaultTableText[2].field = "livePrice";
        return this.defaultTableText;
      }
    },
    tableHeaderClass({ row, rowIndex }) {
      return "dark-header-row";
    },
    getTableHeaders() {
      return this.productData
        .map((element) => {
          const fuelsList = this.$store.getters["fuelsType/getFuelsType"];
          const fuel = fuelsList.find((fuel) => fuel._id === element);
          if (fuel && fuel.name) {
            return {
              fuelName: fuel.name,
              fuelId: element,
            };
          }
        })
        .filter((x) => x != null);
    },
    pagedProductData() {
      let data = this.getTableHeaders;
      if (data && data.length > 0) {
        return data.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
      }
      return [];
    },
    getPageCount() {
      return Math.ceil(this.getTableHeaders.length / this.pageSize);
    },
    getNextPageCount() {
      if (this.page < this.getPageCount - 1) {
        return this.pageSize;
      } else if (this.page === this.getPageCount) {
        return 0;
      } else {
        return this.getTableHeaders.slice(
          this.pageSize * this.getPageCount - this.pageSize,
          this.pageSize * this.getPageCount
        ).length;
      }
    },
    getRemainingColumnsToFillTable() {
      return 5 - this.pagedProductData.length;
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  methods: {
    getRowData(product, rowIndex) {
      let data = this.productPrices.find((x) => x.fuel_id === product.fuelId);
      let fieldRequired = this.getDefaultTableText[rowIndex].field;
      if (data && fieldRequired in data && data[fieldRequired] != null) {
        return this.$options.filters.priceformat(data[fieldRequired]);
      } else {
        return "-";
      }
    },
    getDefaultRowText(index) {
      return this.getDefaultTableText[index].title;
    },
    setPage(val) {
      this.page = val;
    },
    nextPage() {
      if (this.page >= 1) {
        this.page = this.page + 1;
      }
    },
    previousPage() {
      if (this.page <= this.getPageCount) {
        this.page = this.page - 1;
      }
    },
    getFuelLabel() {
      const fuelsList = this.$store.getters["fuelsType/getFuelsType"];
      if (fuelsList) {
        fuel = fuelsList.find((fuel) => fuel._id == fuel_id);
        if (fuel) {
          return fuel.name;
        }
      }
      return "N/A";
    },
  },
};
</script>

<style lang="scss">
.el-table--mini td,
.el-table--mini th {
  padding: 1px 0 !important;
}

.customLineHeight {
  .el-col {
    line-height: 2.5;
    color: map-get($platform-theme, tables-text-color);
  }
}

.customFontSizeTable {
  font-weight: bold;
  font-family: "Nunito Sans", sans-serif;
  color: map-get($platform-theme, tables-text-color);
  .el-col {
    font-size: 1rem;
  }
}

.customFontSizeData {
  color: map-get($platform-theme, tables-text-color) !important;
  font-size: 12px !important;
  font-weight: 400 !important;
}

// overrides to prevent built-in table row hovering
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: initial !important;
}

.remove-text-alignment {
  text-align: initial !important;
}
</style>